import { render, staticRenderFns } from "./doctorTemplate.vue?vue&type=template&id=ff42012e&scoped=true&"
import script from "./doctorTemplate.vue?vue&type=script&lang=ts&"
export * from "./doctorTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./doctorTemplate.vue?vue&type=style&index=0&id=ff42012e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff42012e",
  null
  
)

export default component.exports